// «بوابة مشكاة» fills the whole screen (like F11) while it plays, and
// gives the window back when it ends.
//
// Browsers only allow full screen within a few seconds of a click, tap or
// key — the login button, or the ✨ replay button. When that moment has
// passed (the intro after a reload), the intro asks again on its first tap.
// Someone who leaves full screen themselves (Esc) is not pulled back in.

let entered = false; // we put the page in full screen (so we take it out)
let declined = false; // they left it themselves during this intro

const current = () => document.fullscreenElement || document.webkitFullscreenElement || null;

if (typeof document !== 'undefined') {
  const onChange = () => {
    if (!current() && entered) {
      entered = false;
      declined = true;
    }
  };
  document.addEventListener('fullscreenchange', onChange);
  document.addEventListener('webkitfullscreenchange', onChange);
}

/** `fresh`: a new intro is starting — forget an earlier "no". */
export function enterFullscreen(fresh = false) {
  if (fresh) declined = false;
  if (declined || current()) return;
  const el = document.documentElement;
  const request = el.requestFullscreen || el.webkitRequestFullscreen;
  if (!request) return; // iPhone Safari: no full screen for pages
  try {
    const p = request.call(el, { navigationUI: 'hide' });
    if (p && typeof p.then === 'function') p.then(() => { entered = true; }, () => {});
    else entered = true;
  } catch { /* not allowed right now */ }
}

export function leaveFullscreen() {
  declined = false;
  if (!entered) return;
  entered = false;
  if (!current()) return;
  const exit = document.exitFullscreen || document.webkitExitFullscreen;
  try {
    const p = exit?.call(document);
    if (p && typeof p.catch === 'function') p.catch(() => {});
  } catch { /* already out */ }
}
